import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';
import { format } from 'date-fns';
import { dateColumnOperators, standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { localDay } from '../../../Compounds/UpstackDataGrid/relativeDateOperators';

export const DefaultUserGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    field: 'first_name',
    headerName: 'First Name',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'email',
    headerName: 'Email',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'rolesDisplay',
    headerName: 'Roles',
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'account_name',
    headerName: 'Account Name',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'updated_at',
    headerName: 'Last Login',
    sortable: true,
    valueFormatter: (value) => {
      return value ? format(value, 'PPpp') : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: dateColumnOperators(localDay),
    description: 'Drag to move column'
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    sortable: true,
    valueFormatter: (value) => {
      return value ? format(value, 'PPpp') : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: dateColumnOperators(localDay),
    description: 'Drag to move column'
  }
];
